import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  space,
  layout,
  color,
  compose,
  background,
  SpaceProps,
  LayoutProps,
  ColorProps,
  fontSize,
  FontSizeProps,
  variant,
  ButtonStyleProps,
  LineHeightProps,
  lineHeight,
  BorderProps,
  border,
} from 'styled-system';
import { keyCodes } from '../constants/keycodes';

export type ButtonProps = SpaceProps &
  LayoutProps &
  ColorProps &
  FontSizeProps &
  LineHeightProps &
  BorderProps &
  SpaceProps &
  ButtonStyleProps & { fit?: 'large' | 'small'; marginTop?: string | undefined; cursor?: string | undefined; children: ReactNode };

export const Button = styled.button<ButtonProps>(
  compose(space, layout, color, background, fontSize, lineHeight, border),
  variant({
    variants: {
      primary: {
        bg: 'primary.0',
        color: 'white',
        width: '100%',
        borderRadius: '3px 8px 3px 8px',
        marginTop: '24px',
        py: '8px',
        px: '12px',
        border: '0px',
      },
      secondary: {
        bg: 'secondary.1',
        color: 'white',
        width: '100%',
        borderRadius: '3px 8px 3px 8px',
        marginTop: '24px',
        py: '8px',
        px: '12px',
        border: '1px solid',
        borderColor: 'secondary.1',
        opacity: 1,
        ':hover': {
          opacity: 0.5,
        },
      },
      white: {
        bg: 'white',
        color: 'secondary.1',
        width: '100%',
        borderRadius: '3px 8px 3px 8px',
        marginTop: '24px',
        py: '8px',
        px: '12px',
        border: '0px',
        marginRight: '1%',
      },
      icon: {
        bg: 'transparent',
        border: '0px',
        color: 'inherit',
      },
      transparent: {
        bg: 'transparent',
        color: 'secondary.1',
        width: '100%',
        borderRadius: '3px 8px 3px 8px',
        marginTop: '24px',
        py: '8px',
        px: '12px',
        border: '1px solid',
        borderColor: 'secondary.1',
        marginRight: '1%',
        opacity: 1,
        ':hover': {
          opacity: 0.5,
        },
      },
    },
  }),
  (props) => ({
    cursor: props.cursor,
    marginTop: props.marginTop,
    ...(props.fit && { width: 'auto' }),
    fontFamily: 'inherit',
  })
);

Button.defaultProps = {
  borderWidth: 0,
  type: 'submit',
  py: '8px',
  px: '12px',
  minWidth: 'fit-content',
  variant: 'transparent',
  fontSize: '15px',
  lineHeight: '20px',
  cursor: 'pointer',
  onKeyDown: (e?: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e?.key === keyCodes.Enter) {
      (e?.target as any)?.click && (e?.target as any)?.click();
    }
  },
};

/**Revisar este padding ya que se sobreescribe el paddingY de las variantes */

Button.displayName = 'Button';
